import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from './Components/LoginPage';
import Dashboard from './Components/Dashboard';
import BillingReports from './Components/BillingReports';
import SupportRequest from './Components/SupportRequest';
import TicketDetail from './Components/TicketDetail';
import Settings from './Components/Settings';
import AddUsers from './Components/AddUsers';
import ProtectedRoute from './Components/ProtectedRoute';
import NotFound from './Components/NotFound';
import GroupDetails from './Components/GroupDetails';
import CustomerManagement from './Components/CustomerManagement';
import CustomerDetail from './Components/CustomerDetail';
import GroupManagement from './Components/GroupManagement';
import UserManagement from './Components/UserManagement';
import NoAccessPage from './Components/NoAccessPage';
import ProjectManagement from './Components/ProjectManagement';
import UserInformation from './Components/UserInformation';
import ServiceCatalogManagement from './Components/ServiceCatalogManagement';
// import ProjectTracking from './Components/ProjectTracking';
// import MaintenanceHub from './Components/MaintenanceHub';
// MFA components are imported in UserInformation where they're used
import VerifyEmail from './Components/VerifyEmail';
import { Analytics } from "@vercel/analytics/react"

function App() {
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user ? user.role : null;
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        {/* Hidden in production: redirect to dashboard */}
        <Route path="/project-tracking" element={<Navigate to="/dashboard" replace />} />
        <Route path="/maintenance" element={<Navigate to="/dashboard" replace />} />
        <Route path="/billing-reports" element={<ProtectedRoute><BillingReports /></ProtectedRoute>} />
        <Route path="/support-request" element={<ProtectedRoute><SupportRequest /></ProtectedRoute>} />
        <Route path="/support-request/:ticket_id" element={<ProtectedRoute><TicketDetail /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="/add-users" element={<AddUsers />} />
        <Route path="/groups/:group_id" element={<GroupDetails />} />
        <Route path="/customer-management" element={role === "Admin" ? <ProtectedRoute><CustomerManagement /></ProtectedRoute> : <NoAccessPage />} />
        <Route path="/customer-management/:company_id" element={role === "Admin" ? <ProtectedRoute><CustomerDetail /></ProtectedRoute> : <NoAccessPage />} />
        <Route path="/customer-detail/:company_id" element={role === "Admin" ? <ProtectedRoute><CustomerDetail /></ProtectedRoute> : <NoAccessPage />} />
        <Route path="/group-management" element={role === "Admin" || role === "Customer Admin" ? <ProtectedRoute><GroupManagement /></ProtectedRoute> : <NoAccessPage />} />
        <Route path="/user-management" element={role === "Admin" || role === "Customer Admin" ? <ProtectedRoute><UserManagement /></ProtectedRoute> : <NoAccessPage />} />
        <Route path="/project-management" element={<ProtectedRoute><ProjectManagement /></ProtectedRoute>} />
        <Route path="/service-catalog" element={role === "Admin" ? <ProtectedRoute><ServiceCatalogManagement /></ProtectedRoute> : <NoAccessPage />} />
        <Route path="/user-information" element={<ProtectedRoute><UserInformation /></ProtectedRoute>} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/no-access" element={<NoAccessPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Analytics />
    </Router>
  );
}

export default App;
